// extracted by mini-css-extract-plugin
export default {"customCheckInput":"CheckboxInput_customCheckInput__lY-Y-"};